import * as React from 'react'

import * as hooks from '@bob/hooks'

import * as filter from '../Filters'

type FiltersProps<ITEM> = {
  engine: hooks.useSearchEngine.SearchEngine<ITEM>
}

type Buckets<ITEM> = hooks.useSearchEngine.SearchEngine<ITEM>['result']['facets']['buckets']['buckets']
type Facets<ITEM> = hooks.useSearchEngine.SearchEngine<ITEM>['result']['facets']['buckets']

export function Filters<ITEM>({ engine }: FiltersProps<ITEM>): React.ReactElement {
  const filters = getAllFilters(engine.result, engine.query)

  return <filter.Filters engine={engine} filters={filters} />
}

function getAllFilters<ITEM>(
  result: hooks.useSearchEngine.SearchEngine<ITEM>['result'],
  query: hooks.useSearchEngine.SearchEngine<ITEM>['query'],
): filter.FiltersItems {
  const filters = Object.entries(result.facets).reduce(
    (filtersAccumulator: filter.FiltersItems, [indexHash, index]) => {
      const facet = result.facets[indexHash]
      const indexQuery = query.value.filters[indexHash] || []
      const formattedFilters = formatFilters(index.buckets, indexQuery, facet)

      // HACK: we do not want to display filters with only valu except for signatory filter
      // since there is always only one value
      if (formattedFilters && (formattedFilters.length > 1 || formattedFilters[0]?.id === 'signatory'))
        filtersAccumulator.push({
          filterSlug: indexHash,
          filterTitle: facet.title,
          filterValues: formattedFilters,
        })

      return filtersAccumulator
    },
    [],
  )

  filters.sort((a, b) => (a.filterSlug === 'categories' || b.filterSlug === 'categories' ? 1 : 0))

  return filters
}

function formatFilters<ITEM>(buckets: Buckets<ITEM>, selected: string[], facet: Facets<ITEM>): filter.FilterValue[] {
  return Object.entries(buckets)
    .filter(([buckets]) => {
      if (selected.some((selection) => selection === buckets)) return true
      return facet.buckets[buckets]?.count > 1
    })
    .map(([bucket, bucketIndex]) => {
      return {
        name: bucketIndex.title,
        id: bucket,
        isSelected: selected.some((selection) => selection === bucket),
      }
    })
}
